import commandEngine from './CommandEngine.js';
import jxWindowManager from '../../../../../JxControls/JxWindowManager/JxWindowManager.jsx';

/**
 * Registers the /note command with the CommandEngine.
 * Call once at module load from YourLibraryTab (via CommandEngine.bootup).
 *
 * /note <description> — opens a post-it note, description is free text (joined params)
 */
export function registerNoteCommand() {
    commandEngine.register('/note', {
        hint: 'Open note',
        params: [{ name: 'description', hint: '<description>' }],
        handler: (params) => {
            const body = params.join(' ');
            jxWindowManager.openWindow('JxNoteForm', 'global', { body }, true);
        },
    });
}
